import { render, staticRenderFns } from "./home-graduation.vue?vue&type=template&id=36455268&scoped=true"
import script from "./home-graduation.vue?vue&type=script&lang=js"
export * from "./home-graduation.vue?vue&type=script&lang=js"
import style0 from "./home-graduation.vue?vue&type=style&index=0&id=36455268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36455268",
  null
  
)

export default component.exports